<form [formGroup]="createForm" class="form-validation form-horizontal" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ lang?.sendStakeholders }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body promblbody">

    <!-- <div class="row"> -->

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group color1">
        <div class="col-sm-3">
          <h3 class="popuph3set">{{ lang?.phase }} 01</h3>
        </div>
        <div class="col-sm-9 nopaddno">
          <label class="col-sm-2 nopaddno" for="form-field-2">{{ lang?.attachments }}</label>
          <div class="col-sm-10">
            <table class="repotabenew">

              <tbody>
                <tr  *ngFor="let record of course_att let i = index">
                  <td>{{ record }}</td>
                  <td><input type="checkbox" name="chk1[]" value="{{ record }}" class="bkikecls"></td>
                </tr>

              </tbody>
            </table>

          </div>
        </div>
        <!-- <div class="col-sm-1">
          <input type="checkbox" name="chk1" value="chk1" class="bkikecls">
        </div> -->
      </div>

      <div class="form-group color2">
        <div class="col-sm-3">
          <h3 class="popuph3set">{{ lang?.phase }} 02</h3>
        </div>
        <div class="col-sm-9 nopaddno">
          <label class="col-sm-2 nopaddno" for="form-field-2">{{ lang?.attachments }}</label>
          <div class="col-sm-10">
            <table class="repotabenew">

              <tbody>
                <tr  *ngFor="let record of treatment_att let i = index">
                  <td>{{ record }}</td>
                  <td><input type="checkbox" name="chk1[]" value="{{ record }}" class="bkikecls"></td>
                </tr>



              </tbody>
            </table>

          </div>
        </div>
        <!-- <div class="col-sm-1">
          <input type="checkbox" name="chk1" value="chk1" class="bkikecls">
        </div> -->
      </div>

      <div class="form-group color3">
        <div class="col-sm-3">
          <h3 class="popuph3set">{{ lang?.phase }} 03</h3>
        </div>
        <div class="col-sm-9 nopaddno">
          <label class="col-sm-2 nopaddno" for="form-field-2">{{ lang?.attachments }}</label>
          <div class="col-sm-10">
            <table class="repotabenew">

              <tbody>

                <tr  *ngFor="let record of cause_att let i = index">
                  <td>{{ record }}</td>
                  <td><input type="checkbox" name="chk1[]" value="{{ record }}" class="bkikecls"></td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
        <!-- <div class="col-sm-1">
          <input type="checkbox" name="chk1" value="chk1" class="bkikecls">
        </div> -->
      </div>

      <div class="form-group color4">
        <div class="col-sm-3">
          <h3 class="popuph3set">{{ lang?.phase }} 04</h3>
        </div>
        <div class="col-sm-9 nopaddno">
          <label class="col-sm-2 nopaddno" for="form-field-2">{{ lang?.attachments }}</label>
          <div class="col-sm-10">
             <table class="repotabenew">

              
              <tbody>
                <tr  *ngFor="let record of corrective_att let i = index">
                  <td>{{ record }}</td>
                  <td><input type="checkbox" name="chk1[]" value="{{ record }}" class="bkikecls"></td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
        <!-- <div class="col-sm-1">
          <input type="checkbox" name="chk1" value="chk1" class="bkikecls">
        </div> -->
      </div>
      <div class="form-group color5">
        <div class="col-sm-3">
          <h3 class="popuph3set">{{ lang?.phase }} 05</h3>
        </div>
        <div class="col-sm-9 nopaddno">
          <label class="col-sm-2 nopaddno" for="form-field-2">{{ lang?.attachments }}</label>
          <div class="col-sm-10">
            <table class="repotabenew">
              <tbody>
                <tr  *ngFor="let record of check_att let i = index">
                  <td>{{ record }}</td>
                  <td><input type="checkbox" name="chk1[]" value="{{ record }}" class="bkikecls"></td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
        <!-- <div class="col-sm-1">
          <input type="checkbox" name="chk1" value="chk1" class="bkikecls">
        </div> -->
      </div>

      <div class="form-group col-sm-12">
        <label>{{ lang?.sender }}</label>
        <div class="input-group">
          <span class="input-group-addon">@</span>
          <!-- <input type="text" id="exampleInput" name="input" ng-model="example.value" class="form-control"
            formControlName="execution_date"
            [ngClass]="formErrorClass(createForm.controls.execution_date, createFormSubmitted)" /> -->

            <input type="email" class="form-control" formControlName="r_sender" [ngClass]="formErrorClass(createForm.controls.r_sender, createFormSubmitted)">


            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.r_sender, value:createForm.controls.r_sender, submitted:createFormSubmitted }"></ng-template>

        </div>
      </div>

      <div class="form-group col-sm-12">
        <label>{{ lang?.recipients }}</label>
        <div class="input-group">
          <span class="input-group-addon">@</span>
          <!-- <input type="text" id="exampleInput" name="input" ng-model="example.value" class="form-control"
            formControlName="execution_date"
            [ngClass]="formErrorClass(createForm.controls.execution_date, createFormSubmitted)" /> -->

            <input type="text" class="form-control" formControlName="r_recipient" [ngClass]="formErrorClass(createForm.controls.r_recipient, createFormSubmitted)">


            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.r_recipient, value:createForm.controls.r_recipient, submitted:createFormSubmitted }"></ng-template>

        </div>
      </div>

      <div class="col-sm-12" formArrayName="send_email">
        <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">

          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)" *ngIf=" i!=(send_email().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addEmail()" *ngIf=" i==(send_email().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>

          <div class="col-sm-11">
            <!-- <span class="input-group-addon"></span> -->
            <input type="text" class="form-control" formControlName="{{i}}" [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)" placeholder="Add Cc">
            
            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.send_email, value:send_email().controls[i], submitted:createFormSubmitted }"></ng-template>

          </div>
     
        </div>
      </div>




      <div class="form-group col-sm-12">
        <label>{{ lang?.subject }}</label>

        <!-- <input type="text" id="exampleInput" name="input" ng-model="example.value" class="form-control"
          formControlName="execution_date"
          [ngClass]="formErrorClass(createForm.controls.execution_date, createFormSubmitted)" /> -->

          <input type="text" class="form-control" formControlName="r_subject" [ngClass]="formErrorClass(createForm.controls.r_subject, createFormSubmitted)">


          <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.r_subject, value:createForm.controls.r_subject, submitted:createFormSubmitted }"></ng-template>

      </div>



      <div class="form-group col-sm-12">
        <label>{{ lang?.text }}</label>
        <!-- <textarea class="form-control" formControlName="description"
          [ngClass]="formErrorClass(createForm.controls.description, createFormSubmitted)"></textarea>

        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.description, value:createForm.controls.description, submitted:createFormSubmitted }">
        </ng-template> -->

        <textarea class="form-control" formControlName="r_text" [ngClass]="formErrorClass(createForm.controls.r_text, createFormSubmitted)"></textarea>


        <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.r_text, value:createForm.controls.r_text, submitted:createFormSubmitted }"></ng-template>


      </div>

<!-- 
    </div> -->
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>

    <button type="submit" class="btn btn-success">Send</button>
  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
    <ngx-doc-viewer url="https://angular-doc-viewer.firebaseapp.com/assets/file-sample_150kB.pdf" viewer="google"
      style="width:100%;height:50vh;"></ngx-doc-viewer>
  </div>
</ng-template>